import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { SwitchMenuItem } from '@gem/ui-kit';

import { useCallAccessFormPresenter } from './CallAccessForm.presenter';
import styles from './CallAccessForm.styles.m.css';
import { CallAccessFormProps } from './CallAccessForm.types';

export const CallAccessForm: FC<CallAccessFormProps> = observer((props) => {
  const { t } = useTranslation();
  const presenter = useCallAccessFormPresenter(props);

  return (
    <div className={styles.container}>
      <SwitchMenuItem
        title={t('new_meeting_modal_allow_guests_toogle')}
        subTitle={t('new_meeting_modal_allow_guests_tips')}
        isChecked={presenter.isGuestsAllowed}
        onChange={presenter.switchGuestsAllowed}
        className={styles.switch}
        isDisabled={true}
      />
      <SwitchMenuItem
        title={t('new_meeting_modal_waiting_room_toogle')}
        subTitle={t('new_meeting_modal_waiting_room_tips')}
        isChecked={presenter.isWaitingRoomEnabled}
        onChange={presenter.switchWaitingRoomEnabled}
        className={styles.switch}
        isDisabled={true}
      />
    </div>
  );
});
